export default __webpack_public_path__ + "static/media/Make-a-Claim-not.5822f353.svg";